import Hero_Section_Faq from './Hero_Section_Faq/Hero_Section_Faq';
import Faq from './Faq/Faq';
import Hero_section from "../Blc_Home/Hero_Section/Hero_section";
import Blc_partner from '../Blc_Home/Blc_partner/Blc_partner';
import { Helmet } from 'react-helmet';

const Blc_Faq = (props) => {
    return (
        <div>
            <Helmet>
                <title>Everything About Our Corporate Training Facilities | BRAC</title>
                <meta name="description" content="This page contains answers to frequently asked questions
about our corporate training facilities. Here you will find everything you need to
know." />
                <meta name="keywords" content="venue for training program, training facility provider,
comfortable accommodation, best accommodation facilities, dormitory facilities,
workshop facilities, company picnic venues, venue for corporate events, corporate
training facilities, Learning center services" />
            </Helmet>
            <Hero_Section_Faq valHero={props.valFaq} />
            <Faq valFaqs={props.valFaq} />
            {/* <Blc_partner val={props.valPartner}></Blc_partner> */}
        </div>
    )
}


export default Blc_Faq;
